import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "gap", "isAnchor"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Keep consistent font smoothing for anchor elements.
 *
 * This appears to be a sharp edge when adopting Trellis Foundations Components
 * while UIComponents is present. It picks up UIComponents styling which affects
 * how anchor-based buttons (those with an href) are rendered.
 *
 * We now override the font smoothing so that it's consistently displayed across
 * compositions including the Dropdown which is where this problem was first noticed.
 *
 * @see https://hubspot.slack.com/archives/C06JZNUS8HX/p1748337397132419
 * @see https://git.hubteam.com/HubSpotProtected/intent-and-fit-ui/pull/1967
 */
const StyledAnchorContainer = styled(LayoutHorizontal).withConfig({
  displayName: "ButtonContent__StyledAnchorContainer",
  componentId: "h1ni3m-0"
})(["-webkit-font-smoothing:auto;"]);
export const ButtonContent = _ref => {
  let {
      children,
      gap = 'space-xxs',
      isAnchor = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (isAnchor) {
    return /*#__PURE__*/_jsx(LayoutBox, {
      as: "span",
      display: "flex",
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(StyledAnchorContainer, Object.assign({}, rest, {
        display: "inline-flex",
        forwardAs: "span",
        gap: gap,
        children: children
      }))
    });
  }
  return /*#__PURE__*/_jsx(LayoutHorizontal, Object.assign({}, rest, {
    as: "span",
    display: "inline-flex",
    gap: gap,
    children: children
  }));
};